// Component for displaying the conversation history

import { motion, AnimatePresence } from 'framer-motion';
import type { Message } from '../types';

interface ConversationThreadProps {
  messages: Message[];
}

export function ConversationThread({ messages }: ConversationThreadProps) {
  if (messages.length === 0) {
    return null;
  }

  return (
    <div style={{
      maxWidth: '42rem',
      margin: '0 auto var(--space-4xl)',
      padding: '0 var(--space-xl)'
    }}>
      <div style={{
        width: '100%',
        height: '1px',
        backgroundColor: 'var(--border-color)',
        marginBottom: 'var(--space-3xl)'
      }} />
      
      <AnimatePresence mode="popLayout">
        {messages.map((message, index) => (
          <motion.div
            key={message.id}
            style={{ marginBottom: 'var(--space-3xl)' }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ 
              duration: 0.3,
              delay: index * 0.1,
              ease: "easeOut"
            }}
          >
            <div style={{
              fontSize: 'var(--text-sm)',
              color: 'var(--color-text-secondary)',
              marginBottom: 'var(--space-sm)',
              fontWeight: 500
            }}>
              {message.role === 'user' ? 'You' : 'Oma'}:
            </div>
            
            <div className={message.role === 'oma' ? 'oma-voice' : ''}>
              {message.content.split('\n\n').map((paragraph, pIndex) => (
                <p key={pIndex} style={{ marginBottom: 'var(--space-lg)' }}>
                  {paragraph}
                </p>
              ))}
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
